<template>
  <div class="comp-ic-card">
    <a @click="handleGo">
      <div class="icon" :class="data.Logo">
        <svg-icon :icon-class="data.Logo"></svg-icon>
      </div>
      <div class="text">
        <h4>{{ data.Name }}</h4>
        <p>{{ data.EnName }}</p>
      </div>
      <div class="more">
        <svg-icon icon-class="more"></svg-icon>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "ic-card",
  props: {
    data: {
      type: Object
    }
  },
  methods:{
     handleGo(){
       
      // let baseUrl=window.location.origin
      // let url=`${baseUrl}${this.data.PortalLink}?cid=${this.data.Id}`
      window.open(this.data.PortalLink,'_blank')
     }
     
  },
  mounted(){}
};
</script>

<style lang="scss" scoped>
.comp-ic-card {
  width: 376px;
  height: 88px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  a {
    display: inline-block;
    display: flex;
    width: 100%;
    height: 100%;
    cursor: pointer;
    box-shadow: 0px 4px 8px 0px rgba(154, 168, 222, 0.4);
    &:hover {
      box-shadow: 0px 4px 8px 0px rgba(154, 168, 222, 0.8);
      h4 {
        color: $primary-color;
      }
      .svg-icon {
        color: $primary-color;
      }
    }
  }
  .icon {
    border-radius: 4px 0px 0px 4px;
    width: 92px;
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
    .svg-icon {
      font-size: 46px;
    }
  }
  .icon.ic-gslc,
  .icon.ic-tljt,
  .icon.ic-cgjt,
  .icon.ic-bsd {
    background-color: #52a8e5;
  }
  .icon.ic-gtzh,
  .icon.ic-tdgc,
  .icon.ic-hsjs {
    background-color: #5cc7cf;
  }
  .icon.ic-znzz,
  .icon.ic-ylhl {
    background-color: #f2af50;
  }
  .text {
    padding: 28px 0 0 16px;
    width: 236px;
    h4 {
      font-size: 18px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 18px;
    }
    p {
      font-size: 10px;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
      padding-top: 4px;
      font-family: initial;
    }
  }
  .more {
    display: flex;
    align-items: center;
    justify-content: center;
    .svg-icon {
      font-size: 18px;
      color: #999;
    }
  }
}
</style>
